/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { Button } from "@repo/ui";
import { useUser } from "hooks/use-user";
import moment from "moment";

export default function SLACell({ dataItem }) {
  const user = useUser();
  const isCCA =
    user.Roles.includes("Call Center Agent") || user.Roles.includes("CCA");
  let bgColor = "white";
  let textColor = "black";
  let status = "";
  if (dataItem.sla) {
    const slaState = dataItem.responseSla?.slaStage;

    if (slaState === "WithinSla") {
      bgColor = "#2A9D8F";
      textColor = "#FAFAFA";
      status = "Within SLA";
    } else if (slaState === "AboutToBreach") {
      bgColor = "#f59e0b";
      textColor = "#F5F5F5";
      status = "About To Breach";
    } else if (slaState === "BreachEscalation") {
      bgColor = "#E63946";
      textColor = "#FFFFFF";
      status = "Breached";
    }
  }
  return (
    <td>
      <div className="flex items-center justify-center">
        {dataItem.sla ? (
          <Button
            title={`${status} (${dataItem.slaText})`}
            variant="outline"
            style={{ backgroundColor: bgColor, color: textColor }}
          >
            {dataItem.sla}
          </Button>
        ) : (
          <></>
        )}
      </div>
    </td>
  );
}
